import type { FC } from 'react';
import React, { Children, isValidElement } from 'react';
import cn from 'classnames';
import Helmet from 'react-helmet';

import type { TProps } from './models';
import { FONT_PATH } from './config';

export const FontStyrene: FC<React.PropsWithChildren<TProps>> = ({ children, styles }) => {
    return (
        <>
            <Helmet>
                <link href={FONT_PATH} rel="stylesheet" />
            </Helmet>
            {Children.map(children, elem => {
                if (!isValidElement(elem)) {
                    return elem;
                }

                return (
                    <elem.type
                        key={elem.key}
                        {...elem.props}
                        className={cn(
                            styles.fontStyrene,
                            styles.externalFont,
                            elem.props.className
                        )}
                    />
                );
            })}
        </>
    );
};
